webpackJsonpHairCare(["plugin--ga-tracking-event"],{

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\components\\ga-tracking-event\\ga-tracking-event.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\plugins\\lib\\index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\debug\\src\\browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _gaServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\ga-services.js");

var _klaviyoServices = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\core\\services\\klaviyo-services.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'app.core/modules/ga-tracking-event';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var GaTrackingEvent = function () {
	function GaTrackingEvent(element, options) {
		_classCallCheck(this, GaTrackingEvent);

		this.element = element;
		this.$element = (0, _jquery2.default)(element);
		this.currency = (0, _jquery2.default)('body').data('currency');
		this.type = this.$element.data('type');
		this.watch();
	}

	_createClass(GaTrackingEvent, [{
		key: "watch",
		value: function watch() {
			if (this.type === 'PDP') {
				var product = window.datalayerDataSource;
				if (product) {
					var dataItemList = _gaServices.GAServices.getItemListName(product.item_id);
					var dataTracking = {
						event: 'view_item',
						ecommerce: {
							currency: this.currency,
							items: []
						}
					};
					var item = Object.assign({}, product, dataItemList);
					item.quantity = undefined;
					item.status = item.status || undefined;
					dataTracking.ecommerce.items.push(item);
					_gaServices.GAServices.trackingGA(dataTracking);

					// Click event on select color
					var $colours = this.$element.find('[ga-tracking-link]');
					$colours.each(function (index, color) {
						(0, _jquery2.default)(color).on('click', function (e) {
							var newData = _gaServices.GAServices.getAttributesWithPrefix((0, _jquery2.default)(color), 'data-ga-');
							var colorData = Object.assign({}, item, newData);
							_gaServices.GAServices.saveListItemsName(colorData);
						});
					});
				}
				// Klaviyo track Viewed Product event
				var klaviyoProduct = window.klaviyoDataSource;
				if (klaviyoProduct) {
					_klaviyoServices.KlaviyoServices.trackingKlaviyo('Viewed Product', klaviyoProduct);
					_klaviyoServices.KlaviyoServices.trackViewedItem(klaviyoProduct);
				}
			} else if (this.type === 'Cart Submitted') {
				var cartInfo = window.datalayerDataSource;
				var savedOrderId = localStorage.getItem('orderIdTracking');
				if (cartInfo && !savedOrderId) {
					var data = JSON.parse(localStorage.getItem('cartTrackingData')) || [];
					cartInfo.items = data;
					var _dataTracking = {
						event: 'purchase',
						ecommerce: cartInfo
					};
					_gaServices.GAServices.trackingGA(_dataTracking);
					localStorage.setItem('orderIdTracking', cartInfo.transaction_id);
					var url = this.$element.data('ga-tracking-sent-api-url');
					var orderId = this.$element.data('order-id');
					var urlPost = url + ("?purchaseOrderId=" + orderId + "&value=1");
					var token = (0, _jquery2.default)('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
					fetch(urlPost, {
						method: "POST",
						body: JSON.stringify({
							__RequestVerificationToken: token
						}),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function (response) {
						localStorage.removeItem('selectTrackingData');
						localStorage.removeItem('cartTrackingData');
						localStorage.removeItem('cartKlaviyoTrackingData');
					});
				}
			}
		}
	}]);

	return GaTrackingEvent;
}();

GaTrackingEvent.DEFAULTS = {};

exports.default = GaTrackingEvent;

/***/ })

});


// WEBPACK FOOTER //
// scripts/plugin--ga-tracking-event--3f11299ff0264e0c28c9.js